import React from "react";
import { useNavigate } from "react-router-dom";
import { Dropdown, Tooltip } from "antd";
import { EllipsisOutlined } from "@ant-design/icons";
import { graphicUseMutation } from "../hooks";
import GraphicConst from "../graphic-const";
import { EntityRemoveButton } from "components/service";
import Localize, { localizeByKey, localizeByKeyStatic } from "components/service/localize";
import { TGraphicSupplier } from "../helpers/graphic-types-helper";
import Icons from "components/icons";
import { usePermissionByObject, useIsDeveloper } from "components/permissions/hooks/use-permissions";

interface IGraphicActionFieldProps
{
  graphic: TGraphicSupplier;
}

const GraphicActionField: React.FC<IGraphicActionFieldProps> = ({ graphic }) =>
{
  const navigate = useNavigate();

  const { _setMutationGraphicDelete, loadingMutationGraphicDelete } =
    graphicUseMutation.delete(graphic?.id);

  const { hasPermission: hasUpdatePermission } = usePermissionByObject(GraphicConst.permissions.UPDATE);
  const { hasPermission: hasDeletePermission } = usePermissionByObject(GraphicConst.permissions.DELETE);
  const isDeveloper = useIsDeveloper();

  const canUpdate = isDeveloper || hasUpdatePermission;
  const canDelete = isDeveloper || hasDeletePermission;

  const items = [
    {
      label: (
        <Tooltip title={!canUpdate ? localizeByKeyStatic('PERMISSION.Error_AccessDenied') : undefined}>
          <span className={!canUpdate ? 'disabled' : ''}>
            <Localize>MENUS_DROP.Label_Edit</Localize>
          </span>
        </Tooltip>
      ),
      key: "1",
      icon: <Icons.Edit />,
      disabled: !canUpdate,
      onClick: () => {
        if (canUpdate) {
          navigate(`${GraphicConst.basePath}/${graphic?.id}`);
        }
      },
    },
    {
      key: "2",
      label: (
        <Tooltip title={!canDelete ? localizeByKeyStatic('PERMISSION.Error_AccessDenied') : undefined}>
          <span className={!canDelete ? 'disabled' : ''}>
            <EntityRemoveButton
              modalButton={
                <span style={{ display: "flex", alignItems: "center", width: 100 }}>
                  <Icons.Delete /> <Localize>MENUS_DROP.Label_Delete</Localize>
                </span>
              }
              nameEntity={
                localizeByKey("ENTITY.Modal_Title_Graphic")
              }
              dataNameEntity={graphic?.title}
              loading={loadingMutationGraphicDelete}
              deleteMutation={_setMutationGraphicDelete}
              variables={{
                id: graphic?.id,
              }}
            />
          </span>
        </Tooltip>
      ),
      disabled: !canDelete,
    },
  ];

  return (
    <Dropdown
      // trigger={['click']}
      placement="bottomRight"
      menu={{ items }}
      overlayClassName="drop-more-menu"
      arrow
    >
      <EllipsisOutlined className="btn-more" />
    </Dropdown>
  );
};

export default GraphicActionField;
